import { createSlice } from "@reduxjs/toolkit";
import { fetchTransferRequest } from "./thunk";

interface FetchTransferRequestState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchTransferRequestState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DailyStateSlice = createSlice({
  name: "TransferRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransferRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchTransferRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default DailyStateSlice.reducer;
